import React, { useEffect, useRef, useState } from "react";

const KeyBenefitsSection = ({ benefits }) => {
  const sectionRef = useRef();
  const [visibleIndexes, setVisibleIndexes] = useState([]);

  useEffect(() => {
    const cards = sectionRef.current.querySelectorAll(".benefit-card");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.getAttribute("data-index"), 10);
            setVisibleIndexes((prev) => [...new Set([...prev, index])]);
          }
        });
      },
      { threshold: 0.3 }
    );

    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  const getCardClass = (index) => {
    const directionClass = index < 2 ? "slide-from-left" : "slide-from-right";
    const colorClass = index % 2 === 0 ? "benefit-dark" : "benefit-light";
    const visibilityClass = visibleIndexes.includes(index) ? "show" : "";
    return `benefit-card ${directionClass} ${colorClass} ${visibilityClass}`;
  };

  return (
    <section className="key-benefits-section py-5" ref={sectionRef}>
      <div className="container">
        <h2 className="text-center fw-bold mb-4 text-dark">Key Benefits</h2>
        <div className="row">
          {benefits.map((item, i) => (
            <div className="col-12 col-sm-6 col-lg-3 mb-4" key={i}>
              <div
                className={getCardClass(i)}
                data-index={i}
                style={{ transitionDelay: `${i * 120}ms` }}
              >
                <i className={`bi ${item.icon} benefit-icon`}></i>
                <h5 className="benefit-title">{item.title}</h5>
                <p className="benefit-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyBenefitsSection;
